import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c(VCard,{staticClass:"v-card--no-style"},[(_vm.benefitsUsage.list.length)?_c(VList,{staticStyle:{"background":"none"},attrs:{"three-line":""}},_vm._l((_vm.benefitsUsage.list),function(event,index){return _c('history-item',{key:index,attrs:{"event":event}})}),1):_c(VLayout,[_c(VFlex,{attrs:{"px-4":""}},[_vm._v("Twoja historia jest pusta, zacznij używać karty u naszych partnerów.")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }